var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup331(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.293,
    height: 9.681,
    viewBox: "0 0 10.293 9.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(-136.344 -7.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M8.927,0H1.366A1.366,1.366,0,0,0,0,1.366v6.95A1.366,1.366,0,0,0,1.366,9.681H8.927a1.366,1.366,0,0,0,1.366-1.366V1.366A1.366,1.366,0,0,0,8.927,0",
    transform: "translate(136.344 7.853)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8.92,20.879a2.479,2.479,0,0,0,.173.188,3.1,3.1,0,0,0,1.879.821l.085.006q.09.005.181.005a3.116,3.116,0,0,0,.832-.1.086.086,0,0,0-.016-.168,2.874,2.874,0,0,1-2.33-1.643.592.592,0,0,0-.683-.327.581.581,0,0,0-.371.8,1.543,1.543,0,0,0,.185.338c.021.028.043.056.066.083",
    transform: "translate(129.014 -8.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M30.249,8.354a.583.583,0,0,0-.728-.5.617.617,0,0,0-.431.624,4.053,4.053,0,0,1-2.984,3.7,3.4,3.4,0,0,1-.95.119h-.01a.14.14,0,0,0-.044.274,4.031,4.031,0,0,0,5.147-4.208",
    transform: "translate(115.081 1.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M9.056,46.355a.192.192,0,0,0-.162.081.324.324,0,0,0-.054.2v.512H8.585V45.857h.121a.121.121,0,0,1,.135.135v.3a.4.4,0,0,1,.471-.121q.2.081.2.4v.579H9.258v-.512a.279.279,0,0,0-.054-.2.155.155,0,0,0-.148-.081",
    transform: "translate(129.043 -31.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M16.316,48.461a.4.4,0,0,1-.148.243.512.512,0,0,1-.3.081q-.445-.02-.444-.525c0-.337.148-.512.458-.512s.471.2.444.593h-.646c.013.148.081.229.2.229a.28.28,0,0,0,.162-.067.117.117,0,0,1,.081-.041Zm-.242-.31c-.013-.135-.081-.2-.189-.2s-.175.067-.189.2Z",
    transform: "translate(123.225 -32.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22.134,45.857a.1.1,0,0,1,.081.04.116.116,0,0,1,.04.081V47.15H22V45.857Z",
    transform: "translate(117.636 -31.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M24.564,45.857a.1.1,0,0,1,.081.04.116.116,0,0,1,.04.081V47.15h-.256V45.857Z",
    transform: "translate(115.569 -31.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M27.686,48.272c0,.35-.148.525-.458.525s-.458-.175-.458-.525.148-.525.458-.525.458.175.458.525m-.66,0c0,.2.067.3.2.3s.189-.094.2-.3-.067-.3-.189-.3c-.148-.013-.215.094-.215.3",
    transform: "translate(113.579 -32.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M35.082,48.385a.376.376,0,0,1-.148.242.413.413,0,0,1-.283.081c-.31,0-.458-.175-.471-.525s.148-.525.458-.525a.384.384,0,0,1,.431.323H34.8a.163.163,0,0,0-.162-.108c-.135,0-.2.094-.2.3s.067.3.215.3A.217.217,0,0,0,34.8,48.4a.116.116,0,0,1,.081-.04h.2Z",
    transform: "translate(107.277 -32.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M41.758,48.272c0,.35-.148.525-.458.525s-.458-.175-.458-.525.148-.525.458-.525.458.175.458.525m-.66,0c0,.2.067.3.2.3s.189-.094.2-.3-.067-.3-.189-.3c-.148,0-.215.094-.215.3",
    transform: "translate(101.612 -32.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M48.31,45.947a.138.138,0,0,1,.135.135v.727a.4.4,0,0,1-.471.444c-.31,0-.471-.175-.471-.512s.135-.512.4-.525a.316.316,0,0,1,.283.162v-.431Zm-.337.5c-.135,0-.2.094-.215.3s.067.31.215.31.215-.108.215-.31-.081-.3-.215-.3",
    transform: "translate(95.948 -31.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M55.066,48.461a.4.4,0,0,1-.148.243.512.512,0,0,1-.3.081c-.31-.013-.458-.189-.458-.525s.148-.512.458-.512.471.2.444.593H54.42c.013.148.081.229.2.229a.28.28,0,0,0,.162-.067.116.116,0,0,1,.081-.041Zm-.256-.3c-.013-.135-.081-.2-.189-.2s-.175.067-.189.2Z",
    transform: "translate(90.283 -32.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 10.293,
    height: 9.681,
    transform: "translate(136.344 7.853)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup331);
export default __webpack_public_path__ + "static/media/Group331.962cda898c7e91884af73798d753433f.svg";
export { ForwardRef as ReactComponent };